import React, { createContext, useContext, useState } from 'react'

const TabBarContext = createContext<any>({})

export const TabBarProvider = ({ tabs = [], children }: any) => {
  const [active, setActive] = useState<string>('initial')

  const handleChangeTab = (index: string) => {
    setActive(index)
  }

  const render = (ToRender: any) => {
    if (ToRender) {
      return <ToRender />
    }

    return null
  }

  return (
    <TabBarContext.Provider value={{ active, handleChangeTab }}>
      {
        render(tabs.find((item: any) => item.name === active)?.content)
      }
      {
        children
      }
    </TabBarContext.Provider>
  )
}

export const useTabBarContext = () => {
  const context = useContext(TabBarContext)

  if (!context) throw new Error('useTabBarContext must be used within a provider TabBarProvider')

  return { ...context }
}
